import produce from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import { RootModel } from '../models';
import { storeName as layoutModelStore } from './layout.model';
import { storeName as projectModelStore } from './project.model';
import { storeName as projectItemEntityStoreName } from '../entities/projectItem.entity';
import { storeName as facilityEntityStoreName } from '../entities/facility.entity';
import {
  AMENITIES_LANGUAGE_PATH,
  LanguageTypes,
  MODULE_PAGE_LINK,
  SHARE_LINK_KEY,
} from '../../commons/constants';

export const storeName = 'amenitiesOverviewModel';

type AmenitiesOverviewModelTypes = {
  amenityKey: string;
  facilityKey: string;
  groupFacilityKey: string;
};

const initialState: AmenitiesOverviewModelTypes = {
  amenityKey: null,
  facilityKey: null,
  groupFacilityKey: null,
};

export const amenitiesOverviewModel: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setAmenityKey: produce((state, payload: string) => {
      state.amenityKey = payload;
      state.facilityKey = initialState.facilityKey;
      state.groupFacilityKey = initialState.groupFacilityKey;
    }),
    setGroupFacilityKey: produce((state, payload: string) => {
      state.groupFacilityKey = payload;
      state.facilityKey = initialState.facilityKey;
    }),
    setFacilityKey: produce((state, payload: string) => {
      state.facilityKey = payload;
      state.groupFacilityKey = initialState.groupFacilityKey;
    }),
  },

  effects: (dispatch: RematchDispatch<any>) => ({
    async setAmenityOverview(payload) {
      if (!payload) return;

      await dispatch[projectItemEntityStoreName].loadByKey(payload);
      this.setAmenityKey(payload);
    },

    setFacility(payload: string, state) {
      if (!payload) {
        this.setGroupFacilityKey();
        this.setFacilityKey();
        return;
      }
      const facilityEntity = state[facilityEntityStoreName].ids;
      const facility = facilityEntity[payload];
      if (!facility) return;

      if (facility.numberOfFacilities) {
        this.setGroupFacilityKey(facility.code);
      } else {
        this.setFacilityKey(facility.code);
      }
    },

    setViewOnLocalMap(payload: string, state) {
      const language: LanguageTypes = state[layoutModelStore].locale;

      //  check language and replace projectKey and activeKey
      const linkPageAmenity = dispatch[projectModelStore]
        .getHomePageLink({ link: MODULE_PAGE_LINK })
        .replace(':projectKey', state[projectModelStore].projectKey)
        .replace(':activeKey', AMENITIES_LANGUAGE_PATH[language.locale.toUpperCase()]);

      const { amenityKey, facilityKey, groupFacilityKey } = state[storeName];

      const arrayParamsLinkAmenity: string[] = [];

      if (amenityKey) {
        arrayParamsLinkAmenity.push(`${SHARE_LINK_KEY.AMENITY}=${amenityKey}`);
      }

      if (groupFacilityKey) {
        arrayParamsLinkAmenity.push(`${SHARE_LINK_KEY.FACILITY_GROUP}=${groupFacilityKey}`);
      }

      if (facilityKey) {
        arrayParamsLinkAmenity.push(`${SHARE_LINK_KEY.FACILITY_FOCUS_ITEM}=${facilityKey}`);
      }

      const fullLinkAmenity = `${process.env.REACT_APP_DOMAIN}${linkPageAmenity}#${
        arrayParamsLinkAmenity.length && arrayParamsLinkAmenity.join('&')
      }`;

      dispatch[projectModelStore].setIframeContentData({
        visible: true,
        url: fullLinkAmenity,
      });
    },
  }),
});

export default amenitiesOverviewModel;
